/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'

class ChipsField extends Component {
    render() {
        const { distributorRetailer } = this.props;
        return (
            <div>
                <li>
                    <span>{distributorRetailer.label}</span>
                    <a href="#"><i className="customic ic-close" onClick={(e)=>this.props.handleDRClick(e,distributorRetailer)}></i></a>
                </li>
            </div>
        )
    }
}

export default ChipsField
